import React from "react";
import { DefaultModalForm, useModalDispatch } from "collections/Modal";
import { generatePath } from "polyrouter";
import { ProtectedLink } from "TsRoleGuards";
import { useTranslation } from "utilities/i18n";

const EnableAccountProvisioningModal: React.FC<{ tenant: string }> = ({
  tenant
}) => {
  const dispatchEvent = useModalDispatch();
  const { t } = useTranslation();
  return (
    <DefaultModalForm
      title={t("POLICIES_ENABLE_PROVISIONING")}
      className="pt-2"
      onSubmit={() => {}}
      name="PolicyView-disabled"
    >
      <div className="small-text pt-1" data-testid="enable-provisioning-modal">
        {t("POLICIES_PROVISIONING_INFO")}
      </div>
      <div className="btn-container">
        <button className="btn" onClick={dispatchEvent}>
          {t("BACK")}
        </button>
        <ProtectedLink
          className="btn btn-primary"
          to={generatePath("/admin/accounts/details/:tenantId/provisioning", {
            tenantId: tenant
          })}
          requirement="update:device"
        >
          {t("ACCOUNT_SETTINGS")}
        </ProtectedLink>
      </div>
    </DefaultModalForm>
  );
};

export default EnableAccountProvisioningModal;
